import { useState } from 'react';
import './ActionSection.css';

export default function ActionSection({ sessionId, actions, participants, authorName }) {
  const [content, setContent] = useState('');
  const [owner, setOwner] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!content.trim() || !authorName) return;
    setSubmitting(true);
    try {
      await fetch(`/api/sessions/${sessionId}/actions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content: content.trim(), owner, createdBy: authorName }),
      });
      setContent('');
      setOwner('');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="action-section">
      <div className="action-section-header">
        <h2 className="action-section-title">Actions</h2>
        <span className="action-section-count">{actions.length}</span>
      </div>

      <div className="action-section-body">
        <form className="action-form" onSubmit={handleSubmit}>
          <input
            className="action-input"
            type="text"
            placeholder={authorName ? 'Add an action item…' : 'Enter your name above first'}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            disabled={!authorName || submitting}
          />
          <select
            className="action-select"
            value={owner}
            onChange={(e) => setOwner(e.target.value)}
            disabled={!authorName || submitting}
          >
            <option value="">Unassigned</option>
            {participants.map((p) => (
              <option key={p.id} value={p.name}>{p.name}</option>
            ))}
          </select>
          <button
            className="action-submit"
            type="submit"
            disabled={!content.trim() || !authorName || submitting}
          >
            {submitting ? '…' : 'Add'}
          </button>
        </form>

        <ul className="action-list">
          {actions.map((a) => (
            <li key={a.id} className="action-item">
              <span className="action-checkbox" />
              <span className="action-content">{a.content}</span>
              {a.owner && (
                <span className="action-owner">{a.owner}</span>
              )}
              <span className="action-by">added by {a.createdBy}</span>
            </li>
          ))}
          {actions.length === 0 && (
            <li className="action-empty">No actions yet — add one above.</li>
          )}
        </ul>
      </div>
    </section>
  );
}
